<template>
  <div class="execution">
    <basic-container>
      <avue-crud ref="crud"
                 :page="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @on-load="getList"
                 @refresh-change="refreshChange"
                 @row-del="rowDel">
        <template slot="menuLeft">
          <el-button v-if="permissions.sys_client_add"
            @click="dialogHandleClientVisible = true"
            size="small"
            type="primary">添加
          </el-button>
        </template>
        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     icon="el-icon-view"
                     size="mini"
                     @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button type="text"
                     v-if="permissions.sys_client_edit"
                     icon="el-icon-check"
                     size="mini"
                     @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
          <el-button type="text"
                     v-if="permissions.sys_client_del"
                     icon="el-icon-delete"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog :title="isEdit ? '编辑终端': '新增终端'" :visible.sync="dialogHandleClientVisible"
                @closed="closeDialogHandleClient"
                :before-close="closeDialogHandleClient"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                >
        <el-form :model="clientForm" :rules="clientRules" ref="clientForm" label-width="110px" style="overflow-y:auto; max-height:400px; padding:20px 20px 0 0;">
          <el-form-item label="编号" prop="clientId">
            <el-input v-model="clientForm.clientId" autocomplete="off"
              :disabled="isEdit"
              placeholder="请输入编号"></el-input>
          </el-form-item>
          <el-form-item label="密匙" prop="clientSecret">
            <el-input v-model="clientForm.clientSecret" autocomplete="off" placeholder="请输入密匙"></el-input>
          </el-form-item>
          <el-form-item label="域" prop="scope">
            <el-select v-model="clientForm.scope" multiple placeholder="请选择域">
              <el-option
                v-for="item in scopeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权模式" prop="authorizedGrantTypes">
            <el-select v-model="clientForm.authorizedGrantTypes" multiple placeholder="请选择授权模式">
              <el-option
                v-for="item in authorizedGrantTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回调地址" prop="webServerRedirectUri">
            <el-input v-model="clientForm.webServerRedirectUri" autocomplete="off" placeholder="请输入回调地址"></el-input>
            <span class="client-tip">多个回调地址，使用逗号分隔</span>
          </el-form-item>
          <el-form-item label="权限" prop="authorities">
            <el-input v-model="clientForm.authorities" autocomplete="off" placeholder="请输入权限"></el-input>
          </el-form-item>
          <el-form-item label="自动放行" prop="autoapprove">
            <el-radio-group v-model="clientForm.autoapprove">
              <el-radio
                v-for="(item, index) in autoApproveOptions"
                :key="index"
                :label="item.value">
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="令牌时效（秒）" prop="accessTokenValidity">
            <el-input-number v-model="clientForm.accessTokenValidity" autocomplete="off" placeholder="请输入令牌时效" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="刷新时效（秒）" prop="refreshTokenValidity">
            <el-input-number v-model="clientForm.refreshTokenValidity" autocomplete="off" placeholder="请输入刷新时效" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="资源ID" prop="resourceIds">
            <el-input v-model="clientForm.resourceIds" autocomplete="off" placeholder="请输入资源ID"></el-input>
          </el-form-item>
          <el-form-item label="扩展信息" prop="additionalInformation">
            <el-input type="textarea" v-model="clientForm.additionalInformation" autocomplete="off" placeholder='{ "key": "value" }'></el-input>
            <span class="client-tip">以json对象格式填写内容</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialogHandleClient">取 消</el-button>
          <el-button type="primary" @click="handleClient">保 存</el-button>
        </div>
    </el-dialog>

    <el-dialog title="终端配置详请" :visible.sync="dialogViewclientVisible" @closed="closeDialogViewClient">
      <el-form ref="clientFormInfo" :model="clientForm" label-width="125px" style="overflow-y:auto; max-height:400px; padding:20px 20px 0 0;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="编号：">{{ clientForm.clientId }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密匙：">{{ clientForm.clientSecret }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="域：">{{ clientForm.scope }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="权限：">{{ clientForm.authorities }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资源ID：">{{ clientForm.resourceIds }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="自动放行：">{{ clientForm.autoapprove === 'true' ? '是' : '否' }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="令牌时效（秒）：">{{ clientForm.accessTokenValidity }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="刷新时效（秒）：">{{ clientForm.refreshTokenValidity }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="授权模式：">{{ clientForm.authorizedGrantTypes }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="回调地址：">{{ clientForm.webServerRedirectUri }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="扩展信息：">{{ clientForm.additionalInformation }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogViewClient">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {addObj, delObj, fetchList, putObj} from '@/api/admin/client'
  import {tableOption} from '@/const/crud/admin/client'
  import {mapGetters} from 'vuex'
  import {validateURL, validatenull} from '@/util/validate';

  export default {
    name: 'client',
    data() {
      return {
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        tableLoading: false,
        tableOption: tableOption,
        dialogHandleClientVisible: false,
        dialogViewclientVisible: false,
        isEdit: false,
        clientForm: {
          clientId: '',
          clientSecret: '',
          scope: [],
          authorizedGrantTypes: [],
          webServerRedirectUri: '',
          authorities: '',
          accessTokenValidity: '',
          refreshTokenValidity: '',
          additionalInformation: '',
          resourceIds: '',
          autoapprove: "",
        },
        autoApproveOptions: [
          {
            label: '是',
            value: "true"
          }, {
            label: '否',
            value: "false"
          }
        ],
        authorizedGrantTypeOptions: [
          {
            label: 'password',
            value: 'password'
          }, {
            label: 'refresh_token',
            value: 'refresh_token'
          }, {
            label: 'client_credentials',
            value: 'client_credentials'
          }, {
            label: 'web_code',
            value: 'web_code'
          }, {
            label: 'mobile',
            value: 'mobile'
          }, {
            label: 'wechat_work_code',
            value: 'wechat_work_code'
          }
        ],
        scopeOptions: [
          {
            label: 'server',
            value: 'server'
          }, {
            label: 'userinfo',
            value: 'userinfo'
          }
        ],
        clientRules: {
          clientId: [
            { required: true, message: '请输入编号', trigger: 'blur' }
          ],
          clientSecret: [
            { required: true, message: '请输入密匙', trigger: 'blur' }
          ],
          scope: [
            { required: true, message: '请选择域', trigger: 'change' }
          ],
          authorizedGrantTypes: [
            { required: true, message: '请选择授权模式', trigger: 'change' }
          ],
          autoapprove: [
            { required: true, message: '请选择是否放行', trigger: 'blur' }
          ],
        }
      }
    },
    created() {
    },
    mounted: function () {
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      getList(page, params) {
        this.tableLoading = true
        fetchList(Object.assign({
          current: page.currentPage,
          size: page.pageSize
        }, params)).then(response => {
          this.tableData = response.data.data.records
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      closeDialogHandleClient() {
        this.isEdit = false;
        this.dialogHandleClientVisible = false;
        this.resetClientForm();
        this.$refs.clientForm.clearValidate();
      },
      handleEdit(row, index) {
        this.resetClientForm();
        this.clientForm = {...row};
        if (row.authorizedGrantTypes && row.authorizedGrantTypes !== '') {
          this.clientForm.authorizedGrantTypes = row.authorizedGrantTypes.split(",");
        }
        if (row.scope && row.scope !== '') {
          this.clientForm.scope = row.scope.split(",");
        }
        this.isEdit = true;
        this.dialogHandleClientVisible = true;
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index)
      },
      rowDel: function (row, index) {
        var _this = this
        this.$confirm('是否确认删除ID为' + row.clientId, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return delObj(row.clientId)
        }).then(data => {
          _this.tableData.splice(index, 1)
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          this.refreshChange()
        }).catch(function (err) {
        })
      },
      handleClient() {
        if (!this.handleUris()) {
          this.$message({
            showClose: true,
            message: '请输入正确的回调地址',
            type: 'error'
          })
          return;
        }
        this.$refs.clientForm.validate((valid) => {
          if (valid) {
            let client = {...this.clientForm};
            if (!validatenull(this.clientForm.authorizedGrantTypes)) {
              client.authorizedGrantTypes = this.clientForm.authorizedGrantTypes.join(",");
            }
            if (!validatenull(this.clientForm.scope)) {
              client.scope = this.clientForm.scope.join(",");
            }
            if (this.isEdit) {
              putObj(client).then(res => {
                if (res.data.code === 0 && res.data.data) {
                  this.$message({
                    showClose: true,
                    message: '编辑成功',
                    type: 'success'
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: '编辑失败',
                    type: 'error'
                  })
                }
              }).then(() => {
                this.closeDialogHandleClient();
                this.refreshChange();
              })
            } else {
              addObj(client).then(res => {
                if (res.data.code === 0 && res.data.data) {
                  this.$message({
                    showClose: true,
                    message: '添加成功',
                    type: 'success'
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: '添加失败',
                    type: 'error'
                  })
                }
              }).then(() => {
                this.closeDialogHandleClient();
                this.refreshChange();
              })
            }
          }
        })
      },
      handleUris() {
        let validUrl = true
        if (this.clientForm.webServerRedirectUri && this.clientForm.webServerRedirectUri !== '') {
          this.clientForm.webServerRedirectUri.split(',').forEach( item => {
            validUrl = validUrl && validateURL(item.trim())
          })
        }
        return validUrl;
      },
      handleView(row, index) {
        this.clientForm = {...row};
        this.dialogViewclientVisible = true;
      },
      closeDialogViewClient() {
        this.dialogViewclientVisible = false;
        this.resetClientForm();
      },
      resetClientForm() {
        this.clientForm.clientId= '';
        this.clientForm.clientSecret= '';
        this.clientForm.scope= [];
        this.clientForm.authorizedGrantTypes= [];
        this.clientForm.webServerRedirectUri= '';
        this.clientForm.authorities= '';
        this.clientForm.accessTokenValidity= '';
        this.clientForm.refreshTokenValidity= '';
        this.clientForm.additionalInformation= '';
        this.clientForm.resourceIds= '';
        this.clientForm.autoapprove= "";
      },
      /**
       * 刷新回调
       */
      refreshChange() {
        this.getList(this.page)
      }
    }
  }
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content {
  word-break: break-all;
}
.client-tip {
  font-size: 10px;
}
/deep/.el-input-number__decrease, /deep/.el-input-number__increase {
  bottom: 1px;
}
</style>

